module.exports = __webpack_public_path__ + "img/icon-index-play.69175605.png";